import { render, staticRenderFns } from "./shopVoucherModal.vue?vue&type=template&id=2cf0864d&scoped=true"
import script from "./shopVoucherModal.vue?vue&type=script&lang=js"
export * from "./shopVoucherModal.vue?vue&type=script&lang=js"
import style0 from "./shopVoucherModal.vue?vue&type=style&index=0&id=2cf0864d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf0864d",
  null
  
)

export default component.exports